import axios, {AxiosResponse} from 'axios';
import {IExerciseDialogue} from '../exercise/interfaces';

export const getExerciseToDoApi = (): Promise<AxiosResponse<IExerciseDialogue[]>> => {
  return axios.get(
    `${process.env.REACT_APP_API_URL}/xpedition/exercise/todo/list`
  );
};
export const getExerciseDoneApi = (): Promise<AxiosResponse<IExerciseDialogue[]>> => {
  return axios.get(
    `${process.env.REACT_APP_API_URL}/xpedition/exercise/done/list`
  );
};

export const getExerciseDialogueApi = (id: number): Promise<AxiosResponse<IExerciseDialogue>> => {
  return axios.get(
    `${process.env.REACT_APP_API_URL}/xpedition/exercise/${id}`
  );
};

export const getExerciseStatisticsApi = (): Promise<AxiosResponse<string[]>> => {
  return axios.get(
    `${process.env.REACT_APP_API_URL}/xpedition/exercise/statistics`
  );
};
